var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"elevation-3 d-flex align-center justify-center pa-4",attrs:{"height":_vm.height}},[_c('apexchart',{attrs:{"width":_vm.chartWidth,"type":"donut","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }